import { createContext } from "react";

import { User } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_pb";

// User information - consumed on User page and children components
type UserContextType = {
  user: User;
  setUser: React.Dispatch<React.SetStateAction<User>>;
};

export const UserContext = createContext<UserContextType>(
  {} as UserContextType,
);
